import React from 'react'
import { X } from 'lucide-react'
import { Rnd } from 'react-rnd'
import { mergeClasses } from "../../helpers/styling"
import { SvgIcon, SvgIconType } from '../svg-icon'
import { SimpleTooltip } from './simple-tooltip'
import { PanelBody, PanelHeader, PanelHeaderActions, PanelHeaderTitle, PanelShell } from './panel-chrome'

interface FloatingPanelProps {
  children: React.ReactNode
  title: string
  icon?: SvgIconType
  onClose: () => void
  defaultPosition?: { x: number; y: number }
  defaultSize?: { width: number; height: number }
  minSize?: { width: number; height: number }
  extraHeaderIcons?: React.ReactNode
}

export function FloatingPanel({
                                children,
                                title,
                                icon,
                                onClose,
                                defaultPosition,
                                defaultSize = { width: 800, height: 600 },
                                minSize = { width: 500, height: 350 },
                                extraHeaderIcons,
                              }: FloatingPanelProps) {
  return (
    <Rnd
      default={{
        ...(defaultPosition ?? { x: Math.max(0, window.innerWidth - defaultSize.width - 20), y: 60 }),
        ...defaultSize,
      }}
      minWidth={minSize.width}
      minHeight={minSize.height}
      bounds="window"
      dragHandleClassName="drag-handle"
      style={{ position: 'fixed', zIndex: 100 }}
    >
      <PanelShell>
        <PanelHeader>
          <PanelHeaderTitle icon={icon} title={title} />
          <PanelHeaderActions>
            {extraHeaderIcons}
            <FloatingPanelHeaderIcon title="Close" icon={X} onClick={onClose} />
          </PanelHeaderActions>
        </PanelHeader>
        <PanelBody>
          {children}
        </PanelBody>
      </PanelShell>
    </Rnd>
  )
}

export function FloatingPanelHeaderIcon(props: {
  title: string
  icon: SvgIconType
  onClick: () => void
  disabled?: boolean
  iconSize?: number
}) {
  return (
    <SimpleTooltip tooltip={props.disabled ? null : props.title}>
      <button
        type="button"
        onClick={props.onClick}
        onMouseDown={e => e.stopPropagation()}
        disabled={props.disabled}
        className={mergeClasses(
          "rounded-full p-1 opacity-75 transition",
          props.disabled ? "opacity-50" : "hover:opacity-100 hover:bg-white hover:bg-opacity-25"
        )}
      >
        <SvgIcon icon={props.icon} size={props.iconSize ?? 14} />
      </button>
    </SimpleTooltip>
  )
}
